import React, { MouseEvent, useState, useEffect, useRef } from "react";
import { formatMoneda } from "../../util/varios";
import moment from "moment";
import { Mensaje } from "../../components/mensajes";
import axios from "axios";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import { Dimmer, Loader } from "semantic-ui-react";
import useTable from "../useTable";
import RegistrarPagoNotadeEntregaV from "./registrarPagoNotaEntrega";
import ActualizarVacios from "./actualizarVacios";
import GestionarVacios from "./gestionarVacios";

function GestionVacios(props) {
  const headCells = [
    {
      id: "8",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CODIGO",
      textAlign: "center",
    },
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "N° ENTREGA",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "FECHA",
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CLIENTE",
      textAlign: "center",
    },
    {
      id: "4",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "TOTAL DESPACHADO",
      textAlign: "center",
    },
    {
      id: "5",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "TOTAL RETORNADOS",
      textAlign: "center",
    },
    {
      id: "6",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "TOTAL PENDIENTES",
      textAlign: "center",
    },
    {
      id: "9",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "ACCION",
      textAlign: "center",
    },
    {
      id: "9",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: <i className="fa fa-print" />,
      textAlign: "center",
    },
    {
      id: "10",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "--",
      textAlign: "center",
    },
  ];

  const txtBuscar = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mostrar, setMostrar] = useState(false);
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [opera, setOpera] = useState(0);
  const [idnot, setIdnot] = useState(0);
  const [detavacios, setDetavacios] = useState([]);
  const [abono, setAbono] = useState(0.0);
  const [records, setRecords] = useState([]);
  const [activate, setActivate] = useState(false);

  let token = sessionStorage.getItem("jwtToken");
  let op = require("../../../public/modulos/datos");

  const btncontvacios = JSON.parse(sessionStorage.getItem("btncontvaciosc"));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.numnotavacio
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
                x.numnotaentrega === null
                ? x.numnotavacio
                  .toLowerCase()
                  .includes(target.value.toLowerCase()) ||
                x.cliente
                  .toLowerCase()
                  .includes(target.value.toLowerCase()) ||
                moment(x.fecha)
                  .format("DD-MM-YYYY")
                  .toLowerCase()
                  .includes(target.value.toLowerCase())
                : x.numnotaentrega
                  .toLowerCase()
                  .includes(target.value.toLowerCase()) ||
                x.cliente
                  .toLowerCase()
                  .includes(target.value.toLowerCase()) ||
                moment(x.fecha)
                  .format("DD-MM-YYYY")
                  .toLowerCase()
                  .includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarRegistros = () => {
    let ope = 2;
    let condi = "";

    let endpoint = `${op.conexion}/api/inventariovacio/seleccontrolvaciosdos?&op=${ope}&condi=${condi}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setRecords(response.data);
            txtBuscar.current.focus();
          } else {
            setRecords([]);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const seleccionarDetalleVacios = (numvacio) => {
    let ope = 1;
    let endpoint = `${op.conexion}/api/inventariovacio/seleccontrolvacios?&op=${ope}&condi=${numvacio}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {

          if (response.data.length > 0) {
            setDetavacios(response.data);
            setMostrar1(true);
          } else {
            setDetavacios([]);
            setMostrar1(false);
          }
        }
      })
      .catch(function (error) {

        
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  useEffect(() => {
    seleccionarRegistros();
  }, []);

  const onGestionar = (item, ope) => (e) => {
    if (ope === 2) {
      if (btncontvacios && btncontvacios.toString().substring(0, 1) === "1") {
        seleccionarDetalleVacios(item.numnotavacio);
        setOpera(ope);
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (ope === 3) {
      if (btncontvacios && btncontvacios.toString().substring(2, 3) === "1") {
        setMostrar2(true);
        setOpera(ope);
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (ope === 4) {
      if (btncontvacios && btncontvacios.toString().substring(3, 4) === "1") {
        seleccionarDetalleVacios(item.numnotavacio);
        setOpera(ope);
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (ope === 7) {
      imprimirNotaVacio(item.numnotavacio);
    } else {
      if (btncontvacios && btncontvacios.toString().substring(1, 2) === "1") {
        setAbono(item.abono);
        setIdnot(item.numnotaentrega);
        setMostrar(true);
        setOpera(ope);
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    }
  };

  const imprimirNotaVacio = (num) => {
    if (
      btncontvacios &&
      btncontvacios.toString().substring(4, 5) === "1"
    ) {

      let oper = 1;
      let numnotav = "'"+num+"'";

      var reporte = "ReporteControldeVacios";

      window.open(
        op.reportes +
        "/almacen?afiliado=" +
        afiliado +
        "&reporte=" +
        reporte +
        "&ope=" +
        oper + 
        "&condi=" +
        numnotav,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
      );

    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "¡No Posee Permiso para Realizar esta Acción!",
        icono: "error",
      });
    }
  };

  return (
    <div className="col-md-12 mx-auto">
      <div className="col-md-12 mt-2">
        <div>
          <Mensaje
            mensaje={mensaje}
            onHide={() =>
              setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
            }
          />
          <div className="container-fluid px-3 py-2">
            <div className="row col-md-10 card py-3 mx-auto">
              <div className="row col-md-12 mx-auto">
                <div className="col-md-12 row h-100">
                  <div className="col-md-12 row mx-auto py-3 m-0">
                    <div className="row col-md-12 m-0 px-0">
                      <div className="input-group col-md-6 input-group-sm px-0">
                        <input
                          type="text"
                          onChange={handleSearch}
                          placeholder="Buscar"
                          title="Buscar Clasificador de Vacios"
                          className="form-control text-uppercase"
                          ref={txtBuscar}
                        />
                        <button
                          className="btn"
                          style={{
                            pointerEvents: "none",
                            backgroundColor: "rgba(5, 81, 130, 1)",
                            color: "#FFFFFF",
                          }}
                        >
                          <i className="fa fa-search"></i>
                        </button>
                      </div>
                      <div className="col-pd-60 ml-auto">
                        <button
                          onClick={onGestionar("", 3)}
                          className="btn btn-sm btn-primary rounded-circle mx-1"
                        >
                          <i className="fas fa-plus"></i>{" "}
                        </button>
                      </div>
                    </div>
                    <div className="col-md-12 mt-2 px-0 mx-0 rounded">
                      <TblContainer
                        container={{
                          height: 220,
                          width: "100%",
                          overflow: "auto",
                          padding: "2px",
                          fontSizeAdjust: "0.6",
                        }}
                      >
                        <TblHead />
                        <TableBody className="overflow-hidden table-bordered">
                          {records &&
                            recordsAfterPagingAndSorting().map(
                              (item, index) => (
                                <TableRow key={index} style={{ padding: "0" }}>
                                  <TableCell
                                    className="align-baseline bg-light"
                                    style={{
                                      textAlign: "center",
                                      width: "90px",
                                    }}
                                  >
                                    {item.numnotavacio}
                                  </TableCell>
                                  <TableCell
                                    className="align-baseline bg-light"
                                    style={{
                                      textAlign: "center",
                                      width: "90px",
                                    }}
                                  >
                                    {item.numnotaentrega !== null ? (
                                      <button
                                        className="btn btn-sm btn-info rounded"
                                        title="Visualizar Nota de Entrega"
                                        onClick={onGestionar(item, 1)}
                                      >
                                        {item.numnotaentrega}
                                      </button>
                                    ) : (
                                      "NO"
                                    )}
                                  </TableCell>
                                  <TableCell
                                    className="align-middle"
                                    style={{
                                      textAlign: "center",
                                      width: "80px",
                                    }}
                                  >
                                    {moment(item.fecha).format("DD-MM-YYYY")}
                                  </TableCell>
                                  <TableCell
                                    className="align-middle"
                                    style={{ width: "350px" }}
                                  >
                                    {item.cliente}
                                  </TableCell>
                                  <TableCell
                                    className="align-middle"
                                    style={{
                                      textAlign: "right",
                                      width: "50px",
                                    }}
                                  >
                                    {formatMoneda(
                                      item.totaldespachado
                                        .toString()
                                        .replace(".", ","),
                                      ",",
                                      ".",
                                      2
                                    )}
                                  </TableCell>
                                  <TableCell
                                    className="align-middle"
                                    style={{
                                      textAlign: "right",
                                      width: "50px",
                                    }}
                                  >
                                    {formatMoneda(
                                      item.totaldevuelto
                                        .toString()
                                        .replace(".", ","),
                                      ",",
                                      ".",
                                      2
                                    )}
                                  </TableCell>
                                  <TableCell
                                    className="align-middle"
                                    style={{
                                      textAlign: "right",
                                      width: "50px",
                                    }}
                                  >
                                    {formatMoneda(
                                      item.totalpendiente
                                        .toString()
                                        .replace(".", ","),
                                      ",",
                                      ".",
                                      2
                                    )}
                                  </TableCell>
                                  <TableCell
                                    className="align-middle"
                                    style={{
                                      textAlign: "center",
                                      width: "60px",
                                    }}
                                  >
                                    <button
                                      className="btn btn-sm btn-success rounded"
                                      title="Gestionar Control de Vacio"
                                      onClick={onGestionar(item, 2)}
                                    >
                                      ACTUALIZAR
                                    </button>
                                  </TableCell>
                                  <TableCell
                                    className="align-middle"
                                    style={{
                                      textAlign: "center",
                                      width: "60px",
                                    }}
                                  >
                                    <button
                                      className="btn btn-sm btn-primary rounded"
                                      title="Imprimir"
                                      onClick={onGestionar(item, 7)}
                                    >
                                      <i className="fa fa-print" />
                                    </button>
                                  </TableCell>
                                  <TableCell
                                    className="align-middle"
                                    style={{
                                      textAlign: "center",
                                      width: "50px",
                                    }}
                                  >
                                    <button
                                      className="btn btn-sm btn-danger rounded"
                                      title="Eliminar Control de Vacio"
                                      onClick={onGestionar(item, 4)}
                                    >
                                      <i className="fa fa-trash" />
                                    </button>
                                  </TableCell>
                                </TableRow>
                              )
                            )}
                        </TableBody>
                      </TblContainer>
                      <TblPagination />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <RegistrarPagoNotadeEntregaV
        show={mostrar}
        numnota={idnot}
        abono={abono}
        ope={1}
        onHideCancelar={() => {
          setMostrar(false);
        }}
      />
      <ActualizarVacios
        show={mostrar1}
        ope={1}
        opera={opera}
        data={detavacios}
        onRenderizar={seleccionarRegistros}
        onHideCancelar={() => {
          setMostrar1(false);
        }}
      />
      <GestionarVacios
        show={mostrar2}
        ope={1}
        onRenderizar={seleccionarRegistros}
        onHideCancelar={() => {
          setMostrar2(false);
        }}
      />
      <Dimmer active={activate} inverted>
        <Loader inverted>cargando...</Loader>
      </Dimmer>
    </div>
  );
}

export default GestionVacios;



// WEBPACK FOOTER //
// ./src/components/vacios/tablaVacios.js